// Generated by purs version 0.13.8
"use strict";
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_List = require("../Data.List/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Lunarbox_Data_Char = require("../Lunarbox.Data.Char/index.js");
var Lunarbox_Data_String = require("../Lunarbox.Data.String/index.js");
var TVarName = function (x) {
    return x;
};
var TConstant = (function () {
    function TConstant(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    TConstant.create = function (value0) {
        return function (value1) {
            return new TConstant(value0, value1);
        };
    };
    return TConstant;
})();
var TVariable = (function () {
    function TVariable(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    TVariable.create = function (value0) {
        return function (value1) {
            return new TVariable(value0, value1);
        };
    };
    return TVariable;
})();
var typeString = new TConstant("String", [  ]);
var typePair = function (a) {
    return function (b) {
        return new TConstant("Pair", [ a, b ]);
    };
};
var typeNumber = new TConstant("Number", [  ]);
var typeFunction = function (from) {
    return function (to) {
        return new TConstant("Function", [ from, to ]);
    };
};
var typeBool = new TConstant("Bool", [  ]);
var typeArray = function (content) {
    return new TConstant("Array", [ content ]);
};
var semigroupTVarName = Data_Semigroup.semigroupString;
var output = function ($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof TConstant && (v.value0 === "Function" && v.value1.length === 2)) {
            $copy_v = v["value1"][1];
            return;
        };
        $tco_done = true;
        return v;
    };
    while (!$tco_done) {
        $tco_result = $tco_loop($copy_v);
    };
    return $tco_result;
};
var numberOfInputs$prime = function ($copy_count) {
    return function ($copy_v) {
        var $tco_var_count = $copy_count;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(count, v) {
            if (v instanceof TConstant && (v.value0 === "Function" && v.value1.length === 2)) {
                $tco_var_count = count + 1 | 0;
                $copy_v = v["value1"][1];
                return;
            };
            $tco_done = true;
            return count;
        };
        while (!$tco_done) {
            $tco_result = $tco_loop($tco_var_count, $copy_v);
        };
        return $tco_result;
    };
};
var numberOfInputs = numberOfInputs$prime(0);
var newtypeTVarName = new Data_Newtype.Newtype(function (n) {
    return n;
}, TVarName);
var tvarShow = new Data_Show.Show(Data_Newtype.unwrap(newtypeTVarName));
var multiArgumentFuncionImpl = function (v) {
    return function ($$return) {
        if (v instanceof Data_List_Types.Nil) {
            return $$return;
        };
        if (v instanceof Data_List_Types.Cons) {
            return typeFunction(v.value0)(multiArgumentFuncionImpl(v.value1)($$return));
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Type (line 71, column 1 - line 71, column 54): " + [ v.constructor.name, $$return.constructor.name ]);
    };
};
var multiArgumentFuncion = (function () {
    var $84 = Data_List.fromFoldable(Data_Foldable.foldableArray);
    return function ($85) {
        return multiArgumentFuncionImpl($84($85));
    };
})();
var isArrow = function (v) {
    if (v instanceof TConstant && v.value0 === "Function") {
        return true;
    };
    return false;
};
var printType = function (v) {
    return function (v1) {
        if (v1 instanceof TVariable) {
            return Data_Show.show(tvarShow)(v1.value1);
        };
        if (v1 instanceof TConstant && v1.value1.length === 0) {
            return v1.value0;
        };
        if (v1 instanceof TConstant && (v1.value0 === "Array" && v1.value1.length === 1)) {
            return "[" + (printType(false)(v1["value1"][0]) + "]");
        };
        if (v1 instanceof TConstant && (v1.value0 === "Pair" && v1.value1.length === 2)) {
            return "(" + (printType(false)(v1["value1"][0]) + (", " + (printType(false)(v1["value1"][1]) + ")")));
        };
        if (v1 instanceof TConstant && (v1.value0 === "Function" && v1.value1.length === 2)) {
            var prefix = printType(isArrow(v1["value1"][0]))(v1["value1"][0]);
            var result = prefix + (Lunarbox_Data_String.spaced(Lunarbox_Data_Char.arrow) + Data_Show.show(typeShow)(v1["value1"][1]));
            if (v) {
                return "(" + (result + ")");
            };
            return result;
        };
        if (v1 instanceof TConstant) {
            return v1.value0 + (" " + Data_String_Common.joinWith(" ")(Data_Functor.map(Data_Functor.functorArray)(Data_Show.show(typeShow))(v1.value1)));
        };
        throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Type (line 114, column 1 - line 114, column 39): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var typeShow = new Data_Show.Show(printType(false));
var inputs = function (v) {
    if (v instanceof TConstant && (v.value0 === "Function" && v.value1.length === 2)) {
        return new Data_List_Types.Cons(v["value1"][0], inputs(v["value1"][1]));
    };
    return Data_List_Types.Nil.value;
};
var eqTVarName = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x === y;
    };
});
var ordTVarName = new Data_Ord.Ord(function () {
    return eqTVarName;
}, function (x) {
    return function (y) {
        return Data_Ord.compare(Data_Ord.ordString)(x)(y);
    };
});
var typeEq = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof TConstant && y instanceof TConstant) {
            return x.value0 === y.value0 && Data_Eq.eq(Data_Eq.eqArray(typeEq))(x.value1)(y.value1);
        };
        if (x instanceof TVariable && y instanceof TVariable) {
            return x.value0 === y.value0 && Data_Eq.eq(eqTVarName)(x.value1)(y.value1);
        };
        return false;
    };
});
var createTypeVariable = function (name) {
    return Data_Tuple.Tuple.create(name)(new TVariable(true, name));
};
module.exports = {
    TVarName: TVarName,
    TConstant: TConstant,
    TVariable: TVariable,
    typeNumber: typeNumber,
    inputs: inputs,
    output: output,
    typeBool: typeBool,
    typeString: typeString,
    typeArray: typeArray,
    typeFunction: typeFunction,
    typePair: typePair,
    numberOfInputs: numberOfInputs,
    createTypeVariable: createTypeVariable,
    isArrow: isArrow,
    multiArgumentFuncion: multiArgumentFuncion,
    eqTVarName: eqTVarName,
    ordTVarName: ordTVarName,
    newtypeTVarName: newtypeTVarName,
    semigroupTVarName: semigroupTVarName,
    tvarShow: tvarShow,
    typeEq: typeEq,
    typeShow: typeShow
};
